import * as type from './mutation-types'
import * as API from './api'
import { ajax } from '@/utils/fetch'

// 用户信息
export const exchange = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.EXCHANGE_REQUEST, data)
        // http 请求
    return ajax.post(
        API.exchange, {
            commit
        },
        data,
        type.EXCHANGE_RECEIVE
    )
};